import { reportConstants } from "../constants/reportConstants";

const initialState = {
  sending: false,
  sales: {},
  refund: {},
  error: {},
  transaction: {},
  payout: {},
  reportData: {},
  MonthData: {},
  paymentData: {},
  paymentStatus: {},
  getcommentStatus: {},
  getComment:{},
  getpayoutSummary: {},
  exportAuction: {},
};

export default function reportReducer(state = initialState, action) {
  switch (action.type) {
    case reportConstants.GET_SALESREPORT_REQUEST:
      return {
        sending: true
      };
    case reportConstants.GET_SALESREPORT_SUCCESS:
      return {
        ...state,
        sales: action.data
      };
    case reportConstants.GET_SALESREPORT_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case reportConstants.GET_REFUNDREPORT_REQUEST:
      return {
        sending: true
      };
    case reportConstants.GET_REFUNDREPORT_SUCCESS:
      return {
        ...state,
        refund: action.data
      };
    case reportConstants.GET_REFUNDREPORT_FAILURE:
      return {
        ...state,
        error: action.error
      };

       case reportConstants.GET_PROMOREPORT_REQUEST:
      return {
        sending: true
      };
    case reportConstants.GET_PROMOREPORT_SUCCESS:
      return {
        ...state,
        refund: action.data
      };
    case reportConstants.GET_PROMOREPORT_FAILURE:
      return {
        ...state,
        error: action.error
      };
        case reportConstants.GET_REFUNDARCHIVEREPORT_REQUEST:
      return {
        sending: true
      };
    case reportConstants.GET_REFUNDARCHIVEREPORT_SUCCESS:
      return {
        ...state,
        refund: action.data
      };
    case reportConstants.GET_REFUNDARCHIVEREPORT_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case reportConstants.GET_TRANSACTIONREPORT_REQUEST:
      return {
        sending: true
      };
    case reportConstants.GET_TRANSACTIONREPORT_SUCCESS:
      return {
        ...state,
        transaction: action.data
      };
    case reportConstants.GET_TRANSACTIONREPORT_FAILURE:
      return {
        ...state,
        error: action.message
      };

    case reportConstants.GET_ALLTRANSACTIONREPORT_REQUEST:
      return {
        sending: true
      };
    case reportConstants.GET_ALLTRANSACTIONREPORT_SUCCESS:
      return {
        ...state,
        transaction: action.data
      };
    case reportConstants.GET_ALLTRANSACTIONREPORT_FAILURE:
      return {
        ...state,
        error: action.message
      };
    case reportConstants.GET_PAYOUTREPORT_REQUEST:
      return {
        sending: true
      };
    case reportConstants.GET_PAYOUTREPORT_SUCCESS:
      return {
        ...state,
        payout: action.data
      };
    case reportConstants.GET_PAYOUTREPORT_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case reportConstants.POST_REPORT_REQUEST:
      return {
        sending: true
      };
    case reportConstants.POST_REPORT_SUCCESS:
      return {
        ...state,
        reportData: action.data
      };
    case reportConstants.POST_REPORT_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case reportConstants.GET_MONTH_REQUEST:
      return {
        sending: true
      };
    case reportConstants.GET_MONTH_SUCCESS:
      return {
        ...state,
        MonthData: action.data,
      };
    case reportConstants.GET_MONTH_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case reportConstants.GET_PAYOUTDETAIL_REQUEST:
      return {
        sending: true
      };
    case reportConstants.GET_PAYOUTDETAIL_SUCCESS:
      return {
        ...state,
        paymentData: action.data,
      };
    case reportConstants.GET_PAYOUTDETAIL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case reportConstants.POST_MARKPAYMENT_REQUEST:
      return {
        sending: true
      };
    case reportConstants.POST_MARKPAYMENT_SUCCESS:
      return {
        ...state,
        paymentStatus: action.data,
      };
    case reportConstants.POST_MARKPAYMENT_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case reportConstants.POST_COMMENT_REQUEST:
      return {
        sending: true
      };
    case reportConstants.POST_COMMENT_SUCCESS:
      return {
        ...state,
        getcommentStatus: action.data,
      };
    case reportConstants.POST_COMMENT_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case reportConstants.GET_COMMENT_REQUEST:
      return {
        sending: true
      };
    case reportConstants.GET_COMMENT_SUCCESS:
      return {
        ...state,
        getComment: action.data,
      };
    case reportConstants.GET_COMMENT_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case reportConstants.GET_PAYOUTHISTORY_REQUEST:
      return {
        sending: true
      };
    case reportConstants.GET_PAYOUTHISTORY_SUCCESS:
      return {
        ...state,
        getpayoutSummary: action.data,
      };
    case reportConstants.GET_PAYOUTHISTORY_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case reportConstants.EXPORT_AUCTION_BIDDER_REQUEST:
      return {
        sending: true
      };
    case reportConstants.EXPORT_AUCTION_BIDDER_SUCCESS:
      return {
        ...state,
        exportAuction: action.data
      };
    case reportConstants.EXPORT_AUCTION_BIDDER_FAILURE:
      return {
        ...state,
        error: action.message
      };  
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/reportReducer.js